import { InfoOutlined } from "@mui/icons-material";
import { Box, Card, Stack, Typography } from "@mui/material";
import Dialog from "./Dialog"; // Adjust the import path as needed
import React from "react";
import Translations from "../../lang/en/pages.json"; // Adjust the import path as needed
interface ExplanationDialogProps {
  title: string;
  open: boolean;
  onClose: () => void;
  explanation: string | { [key: string]: string } | null | undefined;
}

const ExplanationDialog: React.FC<ExplanationDialogProps> = ({
  open,
  onClose,
  explanation,
  title
}) => {
  const renderContent = () => {
    if (!explanation) return null;

    if (typeof explanation === "string") {
      return (
        <Stack
          alignItems="center"
          justifyContent="center"
          spacing={2}
          sx={{ p: 2 }}
        >
          <InfoOutlined />
          <Typography variant="h6" fontWeight="medium">
            {title}
          </Typography>
          <Typography fontSize="body1" color="#404943">
            {explanation}
          </Typography>
        </Stack>
      );
    }

    // Handle dictionary case
    return (
      <Stack spacing={3}>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          flexWrap="wrap"
          spacing={3}
        >
          {Object.entries(explanation).map(([key, value], index) => (
            <Card
              key={index}
              sx={{
                minWidth: 200,
                borderRadius: 3,
                padding: 2,
                width: "45%",
                height: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                alignContent: "flex-start",
                justifyContent: "flex-start",
                gap: 2,
                "& .MuiPaper-root": {
                  backgroundColor: "#F5F5F5!important",
                },
              }}
            >
              <Stack
                spacing={4}
                sx={{
                  width: "100%",
                  alignItems: "flex-start",
                }}
              >
                <Box
                  sx={{ backgroundColor: "#D0E8D7", alignSelf: "flex-start" }}
                  borderRadius={3}
                  px={1}
                  py={0}
                >
                  <Typography
                    textTransform="capitalize"
                    fontWeight="bold"
                    variant="caption"
                    color="#3C6472"
                  >
                    {key}
                  </Typography>
                </Box>
                <Typography
                  variant="caption"
                  fontWeight="light"
                  sx={{ color: "#404943" }}
                >
                  {value}
                </Typography>
              </Stack>
            </Card>
          ))}
        </Stack>
      </Stack>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={800}
      minHeight={typeof explanation === "string" ? 200 : "auto"}
    >
      {renderContent()}
    </Dialog>
  );
};

export default ExplanationDialog;
